// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UtKat","label":"styles_label___R8pd"};